module.exports = __webpack_public_path__ + "img/T4-D-rc_23.62036497.png";